<script setup lang="ts">
/**
 * App Footer Component — Donor Portal
 *
 * Footer with company information and links
 */
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const currentYear = new Date().getFullYear();
</script>

<template>
  <div
    class="custom-margin-t px-2 py-3 sm:px-6 lg:px-8 bg-[#F9F0FF]"
  >
    <div class="flex flex-col items-center justify-between gap-4 md:flex-row">
      <!-- Left side -->
      <div class="flex flex-col items-center gap-2 md:items-start">
        <p class="custom-footer-left-text text-sm text-gray-600 dark:text-gray-400">
          © {{ currentYear }} {{ t('donor.footerCompany') }}
        </p>
      </div>

      <!-- Right side -->
      <div class="flex flex-wrap items-center justify-center gap-3 md:justify-end">
        <a
          href="https://www.timelessmedical.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.privacyPolicy') }}
        </a> |
        <a
          href="https://www.timelessmedical.com/terms-conditions/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.termsOfService') }}
        </a> |
        <a
          href="https://www.timelessmedical.com/support/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.support') }}
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-margin-t {
  margin-top: 1.9rem;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.custom-footer-left-text {
  color: var(--color-gray-900);
  font-weight: 500;
  line-height: 20px;
  font-size: 0.875rem;
}

.custom-footer-right-text {
  color: var(--color-primary-600);
  font-weight: 500;
  line-height: 20px;
  font-size: 0.875rem;
}

.footer-link {
  cursor: pointer;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>
